import { IEntity } from '@pf/shared-common';
import {
    ItemFragment,
    PickSearchRequestParams,
    PickStatus,
    PickViewModelCreateBody,
    PickViewModelRead,
    ResourceAuth,
} from '@control-tower/platform-wms';
import {
    ILocationFragmentDto,
    IPickListFragmentDto,
    IPickLocationFragmentDto,
} from '@pf/shared/util-platform';

export type PickRead = PickViewModelRead & IEntity;
export type PickCreate = PickViewModelCreateBody;
export type PickSearchParams = PickSearchRequestParams;

export class PickDto implements IEntity {
    constructor(data: Partial<PickDto>) {
        Object.assign(this, data);
    }

    get name(): string {
        return `${this.pickedQuantity || 0}/${this.quantityNeeded || 0}`;
    }

    id!: string;
    status?: PickStatus;
    location?: ILocationFragmentDto;
    pickList?: IPickListFragmentDto;
    salesOrderLines?: Array<string> | null;
    pickLocations?: Array<IPickLocationFragmentDto> | null;
    quantityNeeded?: number | null;
    pickedQuantity?: number | null;
    needsReview?: boolean;
    item?: ItemFragment;
    itemId?: string;
    quantityToPick?: number;

    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    resourceAuth?: ResourceAuth;
}
